import * as React from 'react'

import {LabelCountry} from "@components";


export default function retailerColumn() {
	return {
		name: 'retailer', label: 'Retailer',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, dataRow) => <LabelCountry
				label={value}
				country={dataRow.country}
			/>
		}
	}
}